import { Module } from 'projects/access-control/src/app/Domain/Entities/module.interface';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { Resource } from 'projects/access-control/src/app/Domain/Entities/resource-interface';
import { IPkSk } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { Versions } from 'projects/access-control/src/app/Domain/Entities/versions.interface';
import { createAction, props } from '@ngrx/store';

export const getModule = createAction('[MODULE] get module ', props<{ pageTo: number }>());
export const getModuleSuccess = createAction(
	'[MODULE] get module success',
	props<{ module: Module[]; pagination: Pagination }>()
);
export const getModuleError = createAction('[MODULE] get Module error', props<{ error: any }>());

export const getAllModule = createAction('[MODULE] get All Module');
export const getAllModuleSuccess = createAction(
	'[MODULE] get All Module success',
	props<{ module: Module[] }>()
);
export const getAllModuleError = createAction(
	'[MODULE] get All module error',
	props<{ error: any }>()
);

export const getSearchModule = createAction(
	'[MODULE] get Search Module',
	props<{ search: string }>()
);
export const getSearchModuleSuccess = createAction(
	'[MODULE] get Search Module success',
	props<{ module: Module[] }>()
);
export const getSearchModuleError = createAction(
	'[MODULE] get Search module error',
	props<{ error: any }>()
);

export const postModule = createAction('[MODULE] Post Module', props<{ module: Module }>());
export const postModuleSuccess = createAction(
	'[MODULE] post module success',
	props<{ module: Module }>()
);
export const postModuleError = createAction('[MODULE] post module error', props<{ error: any }>());

export const updateModule = createAction(
	'[MODULE] updare Module',
	props<{ module: Module; pk: string; sk: string }>()
);
export const updateModuleSuccess = createAction(
	'[MODULE] updare module success',
	props<{ module: Module }>()
);
export const updateModuleError = createAction(
	'[MODULE] updare module error',
	props<{ error: any }>()
);

export const deleteModule = createAction('[MODULE] delete Module', props<{ module: Module }>());
export const deleteModuleSuccess = createAction(
	'[MODULE] delete module success',
	props<{ module: Module }>()
);
export const deleteModuleError = createAction(
	'[MODULE] delete module error',
	props<{ error: any }>()
);

export const postResourceModule = createAction(
	'[MODULE] Post Resource Module',
	props<{ pk: string; sk: string; resource: Resource }>()
);
export const postResourceModuleSuccess = createAction(
	'[MODULE] Post resource Module success',
	props<{ resource: Resource; pk: string; sk: string }>()
);
export const postResourceModuleError = createAction(
	'[MODULE] Post resource Module error',
	props<{ error: any }>()
);

export const updateResourceModule = createAction(
	'[MODULE] Update Resource Module',
	props<{ pk: string; sk: string; resource: Resource }>()
);
export const updateResourceModuleSuccess = createAction(
	'[MODULE] Update resource Module success',
	props<{ resource: Resource; pk: string; sk: string }>()
);
export const updateResourceModuleError = createAction(
	'[MODULE] Update resource Module error',
	props<{ error: any }>()
);

export const getResourcesModule = createAction(
	'[MODULE] get module resources',
	props<{ url: string }>()
);
export const getResourcesModuleSuccess = createAction(
	'[MODULE] get module resources success',
	props<{ resource: Resource[]; pagination: Pagination; pk: string }>()
);
export const getResourcesModuleError = createAction(
	'[MODULE] get module error',
	props<{ error: any }>()
);

//Search General, used in role modal
export const getResourcesSearchModule = createAction(
	'[MODULE] get module search resources',
	props<{ url: string; search: string }>()
);
export const getResourcesSearchModuleSuccess = createAction(
	'[MODULE] get module search resources success',
	props<{ resource: Resource[]; pagination: Pagination; pk: string }>()
);
export const getResourcesSearchModuleError = createAction(
	'[MODULE] get module search resources error',
	props<{ error: any }>()
);

export const deleteResourceModule = createAction(
	'[MODULE] Delete Resource Module',
	props<{ ids: IPkSk[]; module: IPkSk }>()
);
export const deleteResourceModuleSuccess = createAction(
	'[MODULE] Delete Resource Module success',
	props<{ ids: IPkSk[]; pk: string; sk: string }>()
);
export const deleteResourceModuleError = createAction(
	'[MODULE] Delete Resource Module error',
	props<{ error: any }>()
);
export const cleanResources = createAction('[MODULE] clean resouces');

//Get versions
export const getVersionsModule = createAction(
	'[MODULE] Get versions',
	props<{ ids: IPkSk; page: number; search: string }>()
);

export const getVersionsModuleSuccess = createAction(
	'[MODULE] Get versions success',
	props<{ ids: IPkSk; versions: Versions[]; pagination: Pagination }>()
);
export const getVersionsModuleFailure = createAction(
	'[MODULE] Get versions failure',
	props<{ error: any }>()
);

//Post versions

export const postVersionsModule = createAction(
	'[MODULE] Post versions',
	props<{ ids: IPkSk; version: Versions }>()
);

export const postVersionsModuleSuccess = createAction(
	'[MODULE] Post versions success',
	props<{ version: Versions }>()
);
export const postVersionsModuleFailure = createAction(
	'[MODULE] Post versions failure',
	props<{ error: any }>()
);

//Put versions

export const putVersionsModule = createAction(
	'[MODULE] Put versions',
	props<{ ids: IPkSk; idsModule: IPkSk; version: Versions }>()
);

export const putVersionsModuleSuccess = createAction(
	'[MODULE] Put versions success',
	props<{ version: Versions }>()
);
export const putVersionsModuleFailure = createAction(
	'[MODULE] Put versions failure',
	props<{ error: any }>()
);

//Delete versions

export const deleteVersionsModule = createAction(
	'[MODULE] Delete versions',
	props<{ ids: IPkSk[]; module: IPkSk }>()
);

export const deleteVersionsModuleSuccess = createAction(
	'[MODULE] Delete versions success',
	props<{ ids: IPkSk[] }>()
);
export const deleteVersionsModuleFailure = createAction(
	'[MODULE] Delete versions failure',
	props<{ error: any }>()
);
